export default __webpack_public_path__ + "static/media/icon-watch.0e9bf491.svg";